import { c as _c } from "react/compiler-runtime";
import type { VisaTypesResponse } from "@website/ticket-ui/visa/types";
import { MiniPopover, MiniPopoverPropertiesType } from "@website/ui/mini-popover";
type VisaType = {
  onChange: (v: number) => void;
  visaTypes: VisaTypesResponse["Items"];
};
export type VisaTypeProperties = VisaType & MiniPopoverPropertiesType;
type ItemType = {
  label: string;
  onSelect: (value: number) => void;
  value: number;
};
const Item = t0 => {
  const $ = _c(6);
  const {
    label,
    onSelect,
    value
  } = t0;
  let t1;
  if ($[0] !== onSelect || $[1] !== value) {
    t1 = () => onSelect(value);
    $[0] = onSelect;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== label || $[4] !== t1) {
    t2 = <button className="hover:bg-states-neutral-hover flex h-14 cursor-pointer px-6 leading-[56px]" onClick={t1}>{label}</button>;
    $[3] = label;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export const VisaTypePopover = properties => {
  const $ = _c(13);
  const {
    onChange,
    onClose,
    visaTypes
  } = properties;
  let t0;
  if ($[0] !== onChange || $[1] !== onClose) {
    t0 = value => {
      onChange(value);
      onClose();
    };
    $[0] = onChange;
    $[1] = onClose;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onVisaTypeClick = t0;
  let t1;
  if ($[3] !== onVisaTypeClick || $[4] !== visaTypes) {
    let t2;
    if ($[6] !== onVisaTypeClick) {
      t2 = item => <Item key={item.code} label={item.title} onSelect={onVisaTypeClick} value={item.code} />;
      $[6] = onVisaTypeClick;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    t1 = visaTypes.map(t2);
    $[3] = onVisaTypeClick;
    $[4] = visaTypes;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = <div className="flex w-full flex-col">{t1}</div>;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== properties || $[11] !== t2) {
    t3 = <MiniPopover {...properties} title={"\u0646\u0648\u0639 \u0648\u06CC\u0632\u0627"}>{t2}</MiniPopover>;
    $[10] = properties;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};